import styles from './styles.module.scss';
import aboutStyles from '../../../About/styles.module.scss';
import { ReactNode } from 'react';
import { isVac } from "utilities/is-vac";

type Props = {
  title: string;
  siteUrl: string
  imageUrl: string;
  children: ReactNode;
};

export const ResourceItem: React.FC<Props> = ({
  title,
  siteUrl,
  imageUrl,
  children
}) => {
  return (
    <div className={styles.image_block}>
      {imageUrl && <img className={styles.image} src={imageUrl} alt="Resource" />}
      <div className={styles.text_block}>

        {siteUrl ?
        <a href={siteUrl} target="_blank">
          <h3 className={aboutStyles.titleH3}>
            {title}
          </h3>
        </a> : <h3 className={aboutStyles.titleH3}>{title}</h3>
        }

        
        {children}
      </div>
    </div>
  );
};
